module.exports = __webpack_public_path__ + "img/javascript-16-04.5b4e6050.png";